/**
 * LP Banner Reveal Animation
 * スクロールして画面に入ったらふわっと表示
 */

// ページ読み込み時に初期化
document.addEventListener('DOMContentLoaded', function() {
  initBannerReveal();
  initHotspots();
});

// Shopifyテーマエディタでセクションが読み込まれた時に再初期化
document.addEventListener('shopify:section:load', function(event) {
  // lp-bannerセクションの場合のみ再初期化
  if (event.target.querySelector('.lp-banner-section')) {
    initBannerReveal();
    initHotspots();
  }
});

// Shopifyテーマエディタでセクションが選択された時
document.addEventListener('shopify:section:select', function(event) {
  if (event.target.querySelector('.lp-banner-section')) {
    initBannerReveal();
    initHotspots();
  }
});

/**
 * バナー表示アニメーションの初期化
 */
function initBannerReveal() {
  // Intersection Observerで画面に入ったかを検知
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    threshold: 0.1, // 10%画面に入ったら発動
    rootMargin: '0px 0px -50px 0px' // 少し早めに発動
  });

  // すべての.lp-banner-itemを監視
  document.querySelectorAll('.lp-banner-item').forEach(item => {
    observer.observe(item);
  });
}

/**
 * ホットスポット機能
 * 画像上のエリアをクリックしてモーダル表示
 */
function initHotspots() {
  // プレビューモードの検出: URLに?preview=hotspotsがあれば有効
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('preview') === 'hotspots') {
    document.body.classList.add('hotspot-preview-mode');
    console.log('ホットスポット プレビューモード: 有効');
  }

  // モーダル要素の取得
  const modal = document.getElementById('lp-hotspot-modal');
  if (!modal) return; // モーダルがない場合は終了

  const modalImage = modal.querySelector('.lp-hotspot-modal-image');
  const modalClose = modal.querySelector('.lp-hotspot-modal-close');
  const modalOverlay = modal.querySelector('.lp-hotspot-modal-overlay');

  // すべてのホットスポットにクリックイベントを設定
  document.querySelectorAll('.lp-hotspot').forEach(hotspot => {
    hotspot.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const imageUrl = this.getAttribute('data-modal-image');
      if (imageUrl) {
        // モーダル画像を設定して表示
        modalImage.src = imageUrl;
        modal.style.display = 'flex';

        // body のスクロールを無効化
        document.body.style.overflow = 'hidden';
      }
    });
  });

  // 閉じるボタンのクリック
  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  // オーバーレイのクリックで閉じる
  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }

  // ESCキーで閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  });

  // モーダルを閉じる関数
  function closeModal() {
    modal.style.display = 'none';
    modalImage.src = '';

    // body のスクロールを再度有効化
    document.body.style.overflow = '';
  }
}
